
import { defineComponent, watch } from 'vue';
import BaseLoadingSpinner from '@/components/BaseLoadingSpinner.vue';
export default defineComponent({
  components: {
    BaseLoadingSpinner,
  },
  props: {
    list: {
      type: Array,
      default: null,
    },
    speed: {
      type: Number,
      default: 100,
    },
  },
  setup(props) {
    watch(
      () => props.list,
      (newValue) => {
        if (newValue) {
          document.documentElement.style.setProperty(
            '--speed',
            `${props.speed / newValue.length}s`
          );
        }
      }
    );
  },
});
